import Tab from "bootstrap/js/dist/tab";

document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".tabs-block");

  blocks.forEach((block) => {
    const tabButtons = block.querySelectorAll('button[data-bs-toggle="pill"]');
    tabButtons.forEach((tabButton) => {
      Tab.getOrCreateInstance(tabButton);
    });
  });
});
